import { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "./authSlice";
import { useLoginMutation } from "./authApiSlice";
import usePersist from "../../hooks/usePersist";
import { Callout } from "@tremor/react";
// import LandingHeader from "../../components/LandingHeader";
// import LandingFooter from "../../components/LandingFooter";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import Reset from "./Reset";
// import { GoogleLogin } from "@react-oauth/google";

const Login = ({ showModal, closeModal }) => {
  const modalRef = useRef(null);
  const userRef = useRef();
  const errRef = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [persist, setPersist] = usePersist();
  const [warning, setWarning] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showModalResetEmail, setShowModalResetEmail] = useState(false);

  //Za oko u password
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const [login, { isLoading }] = useLoginMutation();

  useEffect(() => {
    setErrMsg("");
  }, [email, password]);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/google/callback`,
          {
            method: "GET",
            credentials: "include", // Omogućava čitanje kolačića postavljenih sa backend-a
          }
        );
        const data = await response.json();

        if (data.accessToken) {
          dispatch(setCredentials({ accessToken: data.accessToken }));
          localStorage.setItem("persist", JSON.stringify(true));
          navigate("/dash"); // Preusmeravanje na glavnu stranicu nakon logovanja
        } else {
          console.error("Nema tokena u odgovoru sa servera");
          console.log("Nema tokena u odgovoru sa servera");
          navigate("/"); // Preusmeravanje na login stranicu u slučaju greške
        }
      } catch (err) {
        console.error("Greška tokom obrade povratka sa Google logovanja:", err);
        console.log("!!!!!!!!!!!!!!");
        //navigate("/"); // Preusmeravanje na login stranicu u slučaju greške
      }
    };

    handleCallback();
  }, [dispatch, navigate]);

  // Close modal if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal(); // Close the modal when clicking outside of it
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeModal]);

  if (!showModal) return null;

  // const handleSubmit = async (e) => {
  //   // e.preventDefault();  //Bilo je

  //   try {
  //     // let email_ = email.toLowerCase();
  //     const { accessToken } = await login({ email, password }).unwrap();
  //     dispatch(setCredentials({ accessToken }));
  //     setEmail("");
  //     setPassword("");
  //     localStorage.setItem("persist", JSON.stringify(true)); //Postavlja persist true kad se uloguje da ne bi se izlovao
  //     navigate("/dash");
  //   } catch (err) {

  //     setErrMsg(err.data?.message);
  //     errRef.current.style = "display:block";
  //     errRef.current.focus();
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isOnlySpaces = (val) =>
      typeof val === "string" && val.trim() === "" && val.length > 0;

    if (email === "" && password === "") {
      setErrMsg("Email i lozinka su obavezni.");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    if (isOnlySpaces(email) || isOnlySpaces(password)) {
      setErrMsg("Neispravni podaci za prijavu.");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    try {
      const { accessToken } = await login({ email, password }).unwrap();
      dispatch(setCredentials({ accessToken }));
      setEmail("");
      setPassword("");
      localStorage.setItem("persist", JSON.stringify(true));
      navigate("/dash");
    } catch (err) {
      setErrMsg(err.data?.message);
      errRef.current.style = "display:block";
      errRef.current.focus();
    }
  };

  const handleUserInput = (e) => setEmail(e.target.value);
  const handlePwdInput = (e) => setPassword(e.target.value);
  const handleToggle = () => setPersist((prev) => !prev);

  const errClass = errMsg ? "errmsg" : "offscreen";

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  //Za monkey sign
  const handleUserInputEmail = (e) => {
    setEmail(e.target.value);
  };

  //work here
  const handleBlur = () => {
    if (!email.includes("@")) {
      // setWarning('Molim vas unesite "@" za meil adresu.');
      setErrMsg(`Molim vas unesite "@" za meil adresu`);
      errRef.current.style = "display:block";
      errRef.current.focus();
    } else {
      setWarning("");
    }
  };
  //Tuna sendvic => tartar
  //Google
  const handleGoogleLogin = () => {
    window.open(`${process.env.REACT_APP_API_URL}/auth/google`, "_self"); // Backend Google ruta
  };

  // const handleGoogleSuccess = async (credentialResponse) => {
  //   try {
  //     const response = await fetch(
  //       "http://localhost:5000/auth/google/callback",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ token: credentialResponse.credential }),
  //       }
  //     );

  //     const data = await response.json();
  //     if (data.accessToken) {
  //       localStorage.setItem("accessToken", data.accessToken);
  //       alert("Login successful!");
  //     }
  //   } catch (err) {
  //     console.error("Error during Google login:", err);
  //   }
  // };

  // const handleGoogleFailure = (err) => {
  //   console.error("Google login failed:", err);
  // };

  //Za reset mail modal
  const openModalResetMail = () => {
    setShowModalResetEmail(true);
  };

  const closeModalResetEmail = () => setShowModalResetEmail(false);

  const handleOverlayClick = (e) => {
    if (e.target.id === "modal-overlay") {
      closeModalResetEmail();
    }
  };

  //Kad se klikne enter onda se loginuje - work here
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(); //Ondoslno login
    }
  };

  const hideError = () => {
    if (errRef.current) {
      errRef.current.style.display = "none";
    }
  };

  // Ovde sam postavio

  const tailwindLogin = (
    <div className="md:w-1/2" ref={modalRef} onClick={handleModalClick}>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* <Callout
          ref={errRef}
          className={errClass}
          color="red-800"
          style={{ display: "none" }}
        >
          {errMsg}
        </Callout> */}
      </div>

      <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[480px] border-4 border-[#66BB6A] rounded-3xl p-4 bg-white z-20">
        <div
          className="bg-white px-3 py-6 shadow rounded-3xl sm:px-6 border-4 border-[#DCC72A]"
          onClick={handleModalClick}
        >
          <Callout
            ref={errRef}
            className={errClass}
            color="red-800"
            style={{ display: "none" }}
          >
            {errMsg}
          </Callout>

          <div className="space-y-6">
            <div className="relative">
              <button
                onClick={closeModal}
                className="absolute top-0 right-0 text-black hover:text-gray-700 text-sm"
                aria-label="Close"
              >
                ✘
              </button>
            </div>
            <h2
              className="mt-1 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900"
              style={{ marginTop: "0px" }}
            >
              Login
            </h2>
            {/* <button
              onClick={handleGoogleLogin}
              style={{
                backgroundColor: "#4285F4",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Prijava putem Google-a  
            </button> */}
            {/* <button
              onClick={handleGoogleLogin}
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                color: "white", // Boja teksta za ikonu
                padding: "10px 20px",
                border: "1px solid black",
                borderRadius: "10px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "500",
                justifyContent: "center", // Centriranje teksta
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/g1.png`}
                alt="Google logo"
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "10px",
                }}
              />
              <span style={{ color: "black" }}>Prijava putem Google-a</span>{" "}
            </button> */}

            {/* <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleFailure}
            /> */}
            {/* <div>
              <label
                htmlFor="text"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email
              </label>
              <div className="mt-2">
                <input
                  type="email"
                  id="username"
                  ref={userRef}
                  value={email}
                  onChange={handleUserInput}
                  autoComplete="off"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  required
                />
              </div>
            </div> */}
            <div>
              <label
                htmlFor="username"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  id="username"
                  value={email}
                  onChange={handleUserInputEmail} // Updated function name
                  onKeyDown={handleKeyDown} //Kad klikne enter
                  onBlur={handleBlur}
                  onFocus={hideError}
                  autoComplete="off"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  required
                />
              </div>
              {warning && (
                <p className="mt-2 text-sm text-red-600">{warning}</p>
              )}
            </div>

            {/* <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Password
              </label>
              <div className="mt-2">
                <input
                  type="password"
                  id="password"
                  onChange={handlePwdInput}
                  value={password}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  required
                />
              </div>
            </div> */}
            {/* work here */}
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Password
              </label>
              <div className="mt-2 relative">
                <input
                  type={isPasswordVisible ? "text" : "password"} // Toggle between text and password
                  id="password"
                  onChange={handlePwdInput}
                  onKeyDown={handleKeyDown} //Kad klikne enter
                  value={password}
                  onFocus={hideError}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  required
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                >
                  {isPasswordVisible ? (
                    <EyeSlashIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  ) : (
                    <EyeIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  )}
                </button>
              </div>
            </div>

            {/* <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
                  id="persist"
                  onChange={handleToggle}
                  checked={persist}
                />
                <label
                  htmlFor="remember-me"
                  className="ml-3 block text-sm leading-6 text-gray-900"
                >
                  Zapamti me
                </label>
              </div>
            </div> */}
            <br />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
                marginTop: "1%",
              }}
            >
              <div className="inline-flex items-center justify-between px-6 py-4 bg-gray-50 rounded-lg shadow-md w-auto">
                <div className="flex items-center">
                  <label
                    htmlFor="remember-me"
                    className="text-sm font-medium text-gray-700 mr-3"
                  >
                    <button
                      // to="/email"
                      onClick={openModalResetMail}
                      className="text-blue-500 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      Zaboravljena lozinka?
                    </button>
                  </label>
                </div>
              </div>

              <br />

              <label style={{ fontWeight: "bold", color: "black" }}>
                Prijava putem Google-a
              </label>

              <button
                onClick={handleGoogleLogin}
                className="flex items-center bg-white text-black py-2 px-4 border border-black rounded-lg cursor-pointer font-medium text-base justify-center w-auto max-w-full mt-2"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/g1.png`}
                  alt="Google logo"
                  className="w-5 h-5 mr-2"
                />
                <span>Google</span>
              </button>
            </div>
            {/* work here */}

            <div className="flex justify-end">
              <button
                // type="submit"
                onClick={handleSubmit}
                className="rounded-full"
                style={{
                  backgroundColor: "#66BB6A",
                  width: "50px",
                  height: "50px",
                  color: "white",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                  transition: "background-color 0.2s",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  className="h-10 w-10"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    d="M5 10h10M10 5l5 5-5 5"
                    stroke="currentColor"
                    strokeWidth="1"
                    fill="none"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modal za Reset loznike */}
      {showModalResetEmail && (
        <div
          id="modal-overlay"
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          {/* <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg p-4"> */}
          <Reset
            showModalResetEmail={showModalResetEmail}
            closeModalResetEmail={closeModalResetEmail}
          />
          {/* </div> */}
        </div>
      )}
    </div>
  );

  return (
    <>
      {/* <LandingHeader /> */}
      {tailwindLogin}
      {/* <LandingFooter /> */}
    </>
  );
};

export default Login;
